<script setup>
// BonBoZ: thẻ một cuộc gọi Zalo (message activity, Rails cập nhật tại chỗ theo
// call_id). Tin cũ vá lại không còn thời lượng/loại -> chỉ hiện câu chung.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';
import { tomTat, bieuTuong, mauBieuTuong } from 'dashboard/helper/cuocGoiZalo';

const { contentAttributes } = useMessageContext();
const { t } = useI18n();

const the = computed(() => contentAttributes.value?.bonbozZaloCuocGoi || {});
const chu = computed(
  () => `${t('BONBOZ.CUOC_GOI.TIEU_DE')} · ${tomTat(the.value, t)}`
);
</script>

<template>
  <div
    class="flex items-center gap-2 px-3 py-2 mx-auto max-w-full rounded-xl border border-n-weak bg-n-solid-1 text-n-slate-12"
    data-bubble-name="zalo-cuoc-goi"
  >
    <span
      class="flex items-center justify-center rounded-full size-7 shrink-0"
      :class="mauBieuTuong(the)"
    >
      <span class="size-4" :class="bieuTuong(the)" />
    </span>
    <span class="text-sm">{{ chu }}</span>
  </div>
</template>
